// Copyright (c) 2017 Deere & Company

import actions from '../actions-list';
import {getDefaultState} from '../state';

const updateVisibility = (state, action) => action.visibility;

export default (state = getDefaultState().isCustomerSearchModalOpen, action) => {

    const actionTypes = {
        [actions.UPDATE_PRODUCTS_BY_CUSTOMER_SEARCH_CUSTOMER_MODAL_VISIBILITY]: updateVisibility
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/product/products-by-customer/reducers/customer-search-modal-visibility.js